import styled from 'styled-components';
//
import colors from 'theme/colors';

const { platinum20, platinum60, primary } = colors;

export default styled.table`
  border-spacing: 0;
  font-size: 14px;
  width: 100%;

  thead {
    background-color: ${platinum20};

    tr {
      height: 50px;
    }

    th {
      text-align: left;
    }
  }

  tbody {
    tr {
      :nth-child(even) {
        background-color: ${platinum60};
      }

      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
  }

  th {
    font-weight: 600;
    font-size: 14px;
    line-height: 1em;
  }

  th,
  td {
    margin: 0;
    padding: 8px;

    :first-child {
      padding-left: 32px;
    }

    :last-child {
      border-right: 0;
      padding-right: 32px;
    }
  }

  a {
    color: ${primary};
  }
`;
